import React, { useContext } from 'react';
import { AgendaContext } from '../../../contexts/AgendaContext';
// Mui components
import { Box, Button, Typography } from '@mui/material';
// Components
import SmallModalContainer from '../../common/SmallModalContainer';
// Icons
import iconWarning from '../../../assets/icons/icon_warning.svg';

function ModalExit({ open, blocker, clearFunction }) {

    const { setProveedorSeleccionado } = useContext(AgendaContext);

    const handleClick = () => {
        clearFunction();
        setProveedorSeleccionado(null);
        blocker.proceed();
    };

    return (
        <SmallModalContainer open={open}>
            <Box display="flex" flexDirection="column" gap={"1rem"}>
                <Box
                    component="img"
                    sx={{ width: "54px", height: "54px" }}
                    alt="img not found"
                    src={iconWarning}
                />
                <Typography variant="h1">¿Querés salir sin enviar tu solicitud?</Typography>
                <Typography variant="h5" component="p">Si lo hacés, perderás los datos que cargaste.</Typography>
                <Box display="flex" gap={"1rem"} marginTop="1.5rem">
                    <Button
                        variant="outlined"
                        sx={{ height: "48px", borderRadius: "16px", borderWidth: "2px", width: "50%" }}
                        onClick={() => blocker.reset()}
                    >
                        <Typography variant="cta" component="span">
                            Mejor no
                        </Typography>

                    </Button>
                    <Button
                        variant="contained"
                        sx={{ height: "48px", borderRadius: "16px", width: "50%" }}
                        onClick={() => handleClick()}
                    >
                        <Typography variant="cta" component="span">Sí, quiero salir</Typography>
                    </Button>

                </Box>
            </Box>
        </SmallModalContainer>
    );
}

export default ModalExit;